import React from 'react';
import PropTypes from 'prop-types';
import StackedBars from 'components/common/charts/StackedBars';
import Bubbles from 'components/common/charts/Bubbles';
import Table from 'components/common/charts/Table';
import { getGraphType } from 'utils/countryProfile';
import { GRAPH_TYPES_TITLES } from 'constants/countryProfile';

class GraphType extends React.Component {
  getGraph(type) {
    const { country, data, horizontal } = this.props;
    const hasData = data && !!data.length;
    const isArcData = hasData && !!Object.keys(data[0]).find(k => k === 'law');
    const isTableData = hasData && !!Object.keys(data[0]).find(k => k === 'direction-scores');
    const isBubblesData = hasData && !!Object.keys(data[0]).find(k => k === 'x');

    switch (true) {
      case (type === 'arc' && isArcData): return <StackedBars id="arc1" horizontal={horizontal} data={this.parseStackedGraphData(data)} />;
      case (type === 'bubbles' && isBubblesData): return <Bubbles id="bubbles" data={data} country={country} />;
      case (type === 'table' && isTableData): return <Table country={country} data={this.parseTableGraphData(data)} />;
      default: return '';
    }
  }
  getCurrentDataPoint(data) {
    return data.find(it => {
      const countrySectorYearData = it['country-sector-year-data'];
      if (!countrySectorYearData) return false;
      const countrySector = countrySectorYearData['country-sector'];
      if (!countrySector) return false;
      return countrySector.country.name === this.props.country && countrySector.sector.name === this.props.sector;
    });
  }
  parseTableGraphData(data) {
    const current = this.getCurrentDataPoint(data);
    return current ? current['direction-scores'] : [];
  }

  parseStackedGraphData(data) {
    const current = this.getCurrentDataPoint(data);
    return current ? [
      { label: 'Law', value: current.law, gap: current.gap < 0 ? 0 : Math.abs(current.gap) },
      { label: 'Practice', value: current.practice, gap: current.gap < 0 ? Math.abs(current.gap) : 0 }
    ] : [];
  }

  render() {
    const { type, text, titleName } = this.props;
    const title = type ? GRAPH_TYPES_TITLES[type].name : '';
    const graphType = getGraphType(type);

    return (
      <article className="c-graph-type">
        <div className="row">
          <div className="graph column small-12 medium-10 medium-offset-1">
            <h2 className="subtitle">{titleName}: {title}</h2>
            {/* Graph */}
            <div className="graph-item">
              {this.getGraph(graphType)}
              {graphType === 'arc' &&
                <div className="legend">
                  <p className="legend-label"><span className="icon -gap" /><span>Gap</span></p>
                </div>
              }
            </div>
          </div>
          <div className="column small-12 medium-10 medium-offset-1">
            <p dangerouslySetInnerHTML={{ __html: text }}></p>
          </div>
        </div>
      </article>
    );
  }
}

GraphType.propTypes = {
  country: PropTypes.string,
  sector: PropTypes.string,
  titleName: PropTypes.string,
  horizontal: PropTypes.bool,
  data: PropTypes.any,
  text: PropTypes.any,
  type: PropTypes.string
};

export default GraphType;



// WEBPACK FOOTER //
// ./app/components/country-profiles/show/GraphType.jsx